/**
 * ContactDialing component (Call Us page redesign container)
 * Using ErrorHandler to handle Error case in the Call us page, which is same with current Call Us error handler
 */

import React from 'react';

// Helper
import ModalContainer from '../containers/ModalContainer';
import ErrorHandler from '../containers/ErrorHandler';
import Callus from '../containers/Call';
import i18n from '../../lib/reacti18n';

const contactError = i18n.message('smarthelp/Error.error.contact');

const renderCallusPage = () => <Callus />;

const ContactDialing = function () {
  return (
    <ErrorHandler contactError={contactError}>
      <div>
        <ModalContainer />
        {renderCallusPage()}
      </div>
    </ErrorHandler>
  );
};

export default ContactDialing;
